// ============================================
// PROFILE DROPDOWN MODULE
// ============================================
// Obsługuje otwieranie/zamykanie dropdown profilu
// Trigger: kliknięcie .navbar__profile-toggle
// Zamknięcie: kliknięcie close, kliknięcie poza, Escape
// ============================================

(function () {
    'use strict';

    var triggers = document.querySelectorAll('.navbar__profile-toggle');
    var dropdown = document.getElementById('dropdown-profile');

    if (!triggers.length || !dropdown) return;

    var closeBtn = dropdown.querySelector('.dropdown-profile__close');

    function openDropdown() {
        // Close any open megamenus first
        var openMegamenus = document.querySelectorAll('.megamenu.is-open');
        openMegamenus.forEach(function (m) {
            m.classList.remove('is-open');
            m.setAttribute('aria-hidden', 'true');
        });
        var openMegamenuItems = document.querySelectorAll('.nav-item--has-megamenu.is-open');
        openMegamenuItems.forEach(function (item) {
            item.classList.remove('is-open');
            var btn = item.querySelector('.nav-link');
            if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        dropdown.classList.add('is-open');
        dropdown.setAttribute('aria-hidden', 'false');
        triggers.forEach(function (t) {
            t.setAttribute('aria-expanded', 'true');
        });
    }

    function closeDropdown() {
        dropdown.classList.remove('is-open');
        dropdown.setAttribute('aria-hidden', 'true');
        triggers.forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
        });
    }

    function toggleDropdown() {
        if (dropdown.classList.contains('is-open')) {
            closeDropdown();
        } else {
            openDropdown();
        }
    }

    // Toggle on trigger click
    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        });
    });

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            closeDropdown();
        });
    }

    // Close on click outside
    document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target) && !e.target.closest('.navbar__profile-toggle')) {
            if (dropdown.classList.contains('is-open')) {
                closeDropdown();
            }
        }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
            closeDropdown();
        }
    });

    // Close on resize (when switching between mobile/desktop, re-align automatically via CSS)
    // No action needed — CSS handles repositioning.
})();
